import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import styles from './ActionDrawer.module.scss';

function ActionDrawer({
  open,
  eyebrow,
  title,
  description,
  children,
  footer,
  onClose,
  closeDisabled = false,
}) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleKeyDown = event => {
      if (event.key === 'Escape' && !closeDisabled) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    document.body.classList.add('navigation-open');
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('navigation-open');
    };
  }, [open, onClose, closeDisabled]);

  if (!open || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div className={styles.layer} role="presentation">
      <button
        type="button"
        className={styles.backdrop}
        onClick={onClose}
        disabled={closeDisabled}
        aria-label="Close panel"
      />
      <aside
        className={styles.drawer}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
      >
        <header className={styles.header}>
          <div>
            {eyebrow && <p>{eyebrow}</p>}
            <h2 id="drawer-title">{title}</h2>
            {description && <span>{description}</span>}
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            disabled={closeDisabled}
            aria-label="Close panel"
          >
            <X size={20} />
          </button>
        </header>
        <div className={styles.body}>{children}</div>
        {footer && <footer className={styles.footer}>{footer}</footer>}
      </aside>
    </div>,
    document.body
  );
}

export default ActionDrawer;
